const userLoggedSelector = ({ loginState }) => loginState.userLogged

export {
    userLoggedSelector
}